module.exports = __webpack_public_path__ + "static/media/signage-indoor-img53.d5f567e7.jpg";